function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { cell, cellContents } from "./cell";
import { lineHeightTight, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { Context } from "./settings/context";
export const StyledTD = styled.td.withConfig({
  componentId: "sc-8selpg-0"
})(["", " ", " line-height:", ";", ""], cell, cellContents, lineHeightTight, ({
  dataType,
  editing
}) => editing || dataType === "actions" ? `padding-top: ${spacing8}; padding-bottom: ${spacing8};` : "");

const TD = ({
  type = "normal",
  editing = false,
  children,
  ...props
}) => {
  const {
    spacing,
    verticalRuled,
    horizontalRuled
  } = useContext(Context);
  return /*#__PURE__*/React.createElement(StyledTD, _extends({}, props, {
    spacing: spacing,
    verticalRuled: verticalRuled,
    horizontalRuled: horizontalRuled,
    editing: editing,
    dataType: type
  }), children);
};

export default TD;
TD.propTypes = {
  /** The data type. */
  type: PropTypes.oneOf(["normal", "number", "actions"]),

  /** Whether the cell is currently being edited. When true, the cell is expected to contain a form control. */
  editing: PropTypes.bool,

  /** The cell contents. */
  children: PropTypes.node
};